import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DateFormatService } from 'src/app/shared/services/date-format.service';

@Component({
  selector: 'app-tax-date-picker',
  templateUrl: './tax-date-picker-modal.component.html',
  styleUrls: ['./tax-date-picker-modal.component.less'],
  standalone: false
})
export class TaxDatePickerComponent implements OnInit {
  @Input() itemDetails: any;
  @Input() taxDate: Date = new Date();
  @Input() documentDate: Date = new Date();
  @Input() sstReturnStatus: boolean = false;

  constructor(
    private http: HttpClient,
    private message: NzMessageService,
    public dateFormatService: DateFormatService
  ) {}

  ngOnInit(): void {
    if (this.taxDate === null) {
      this.taxDate = this.documentDate;
    }
  }

  disabledDate = (current: Date): boolean => {
    // Make sure documentDate is a proper Date object
    const docDate =
      this.documentDate instanceof Date
        ? this.documentDate
        : new Date(this.documentDate);

    // Compare dates based only on year, month, and day (ignoring time)
    const currentDate = new Date(current.getFullYear(), current.getMonth(), current.getDate());
    const documentDate = new Date(docDate.getFullYear(), docDate.getMonth(), docDate.getDate());
    
    // Disable dates before documentDate, allow selecting documentDate and any date after
    return currentDate < documentDate;
  };

  formatDateForHttp = (date: Date | null): string => {
    if (!date) return '';
    return date.toISOString().split('T')[0];
  };

  validateTaxDate() {
    if (!this.taxDate) {
      this.message.error('Please select a tax date');
      return Promise.resolve(false);
    }

    // Filter out null items and items with null taxCode
    const filteredItems = this.itemDetails ? 
      (Array.isArray(this.itemDetails) ? this.itemDetails.filter(item => item !== null && item !== undefined && item.taxCode !== null) : this.itemDetails) : 
      [];
    
    const requestBody = {
      taxDate: this.taxDate,
      itemDetails: filteredItems
    };

    return new Promise<boolean>(resolve => {
      this.http
        .post<{
          isValid: boolean;
          status: boolean;
        }>('api/sstreturns/ValidateTaxDate?_silent=true', requestBody)
        .subscribe({
          next: response => {
            this.sstReturnStatus = response.status;
            if (response.isValid) {
              resolve(true);
            } else {
              this.message.error('Invalid tax date. Please try again.');
              resolve(false);
            }
          },
          error: error => {
            this.message.error('Error validating tax date');
            resolve(false);
          }
        });
    });
  }
}
